import React, { Fragment, memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import { Box, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import { useLangFile } from 'js/context/LanguageContext';
import CircularProgress from '@mui/material/CircularProgress';

const PrescriptionSaveDialog = ({ open, onCancel, onRecalculate, isBulkPrescription }) => {
  const LangFile = useLangFile();

  return (
    <Fragment>
      <Dialog open={Boolean(open)} fullWidth maxWidth={'md'}>
        <DialogTitle> {LangFile.PrescriptionRecalculate.recalculatePrescription}</DialogTitle>
        <DialogContent style={{ overflow: 'hidden' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {isBulkPrescription
              ? LangFile.PrescriptionRecalculate.bulkRecalculateInfo
              : LangFile.PrescriptionRecalculate.recalculateInfo}
            <br />
            {LangFile.PrescriptionRecalculate.areYouSure}
          </Box>
        </DialogContent>
        <DialogActions>
          <Fragment>
            <Button onClick={onCancel} color={'inherit'} variant={'outlined'}>
              {LangFile.PrescriptionRecalculate.cancel}
            </Button>

            <Button onClick={onRecalculate} color={'primary'} variant={'contained'}>
              {LangFile.PrescriptionRecalculate.recalculate}
            </Button>
          </Fragment>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default memo(PrescriptionSaveDialog);

PrescriptionSaveDialog.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onRecalculate: PropTypes.func.isRequired,
  isBulkPrescription: PropTypes.bool,
};
